import { motion } from 'framer-motion'

const SvgComponent = ({ transition, ...props }) => (
  <motion.svg
    initial={{
      y: '30%',
      x: '-15%',
      scale: 0.75,
      opacity: 0
    }}
    animate={{
      y: '-10%',
      opacity: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}

    viewBox="0 0 278 383"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4} filter="url(#njp88qtv6a)">
      <circle
        cx={105.546}
        cy={277.129}
        r={105.129}
        transform="rotate(90 105.546 277.129)"
        fill="url(#knwc5jlj1b)"
      />
    </g>
    <circle
      opacity={0.1}
      cx={111.113}
      cy={48.627}
      r={39.703}
      transform="rotate(15 111.113 48.627)"
      fill="url(#1bdy456u1c)"
    />
    <path
      d="M204.994 215.925c-5.782 0-10.513-1.791-14.192-5.373-3.68-3.581-5.52-8.186-5.52-13.814s1.84-10.232 5.52-13.814c3.679-3.581 8.41-5.372 14.192-5.372s10.513 1.791 14.193 5.372c3.679 3.582 5.519 8.186 5.519 13.814s-1.84 10.233-5.519 13.814c-3.68 3.582-8.411 5.373-14.193 5.373zm-34.167 41.058c-2.19 0-4.052-.746-5.585-2.238-1.533-1.493-2.3-3.305-2.3-5.436v-4.349c0-3.241.833-6.012 2.497-8.314 1.665-2.303 3.811-4.051 6.439-5.245 5.87-2.558 11.499-4.476 16.887-5.755a69.986 69.986 0 0 1 16.229-1.919c5.432 0 10.82.661 16.164 1.983 5.344 1.321 10.951 3.219 16.82 5.691 2.716 1.194 4.907 2.942 6.571 5.245 1.665 2.302 2.497 5.073 2.497 8.314v4.349c0 2.131-.767 3.943-2.3 5.436-1.533 1.492-3.395 2.238-5.585 2.238h-68.334z"
      fill="url(#d3xs00xh6d)"
    />
    <path
      d="M197.519 204.045c4.361 4.142 9.968 6.214 16.821 6.214 6.853 0 12.459-2.072 16.82-6.214 4.361-4.143 6.542-9.47 6.542-15.98s-2.181-11.837-6.542-15.98c-4.361-4.143-9.967-6.214-16.82-6.214s-12.46 2.071-16.821 6.214c-4.361 4.143-6.541 9.47-6.541 15.98s2.18 11.837 6.541 15.98z"
      fill="url(#nbee5vp6he)"
      style={{
        mixBlendMode: "luminosity",
      }}
      opacity={0.7}
    />
    <path
      d="M276.278 154.172h-10.754V95.707h-15.456v58.465h-3.58v-9.911h-15.456v9.911h-4.483v-51.031h-15.456v51.031h-2.671v-30.34h-15.456v30.34h-2.632v-43.356h-15.456v43.356h-9.567V75.895c0-1.515-2.369-1.515-2.369 0v79.456c0 .637.542 1.175 1.182 1.175h112.149c1.525 0 1.525-2.354 0-2.354h.005z"
      fill="url(#fz8tyjtr9f)"
    />
    <path
      d="M153.597 106.298c0 22.579-18.304 40.883-40.883 40.883-22.58 0-40.884-18.304-40.884-40.883 0-22.58 18.304-40.884 40.884-40.884 22.579 0 40.883 18.304 40.883 40.884zm-69.75 0c0 15.942 12.924 28.867 28.867 28.867 15.943 0 28.867-12.925 28.867-28.867 0-15.943-12.924-28.867-28.867-28.867-15.943 0-28.867 12.924-28.867 28.867z"
      fill="url(#caklmf40dg)"
    />
    <g filter="url(#9h700gxdgh)">
      <circle cx={110.378} cy={199.746} r={40.884} fill="url(#c2je88wfdi)" />
    </g>
    <path
      opacity={0.5}
      d="M160.606 199.746a50.234 50.234 0 0 1-14.711 35.517 50.224 50.224 0 0 1-35.517 14.711v-50.228h50.228z"
      fill="url(#80e4zkgl1j)"
    />
    <path
      opacity={0.5}
      d="M112.714 142.509a36.206 36.206 0 0 0 25.605-10.606 36.215 36.215 0 0 0 10.606-25.605h-11.894a24.315 24.315 0 0 1-15.012 22.466 24.315 24.315 0 0 1-9.305 1.851v11.894z"
      fill="url(#wh3ieubpnk)"
    />
    <defs>
      <linearGradient
        id="knwc5jlj1b"
        x1={226.007}
        y1={312.172}
        x2={-10.554}
        y2={312.035}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="1bdy456u1c"
        x1={122.675}
        y1={14.427}
        x2={105.033}
        y2={78.162}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="d3xs00xh6d"
        x1={164.299}
        y1={258.353}
        x2={220.633}
        y2={178.055}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9655FA" />
        <stop offset={1} stopColor="#FD6EC1" />
      </linearGradient>
      <linearGradient
        id="nbee5vp6he"
        x1={197.9}
        y1={205.056}
        x2={230.227}
        y2={167.794}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="fz8tyjtr9f"
        x1={236.847}
        y1={80.426}
        x2={223.403}
        y2={148.426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="caklmf40dg"
        x1={111.546}
        y1={46.724}
        x2={111.546}
        y2={227.781}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="c2je88wfdi"
        x1={122.283}
        y1={164.529}
        x2={104.117}
        y2={230.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="80e4zkgl1j"
        x1={37.188}
        y1={201.181}
        x2={259.628}
        y2={201.181}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="wh3ieubpnk"
        x1={100.643}
        y1={147.79}
        x2={100.69}
        y2={66.308}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <filter
        id="njp88qtv6a"
        x={-3.583}
        y={168}
        width={218.259}
        height={218.259}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10269"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10269"
          result="shape"
        />
      </filter>
      <filter
        id="9h700gxdgh"
        x={65.494}
        y={154.862}
        width={89.768}
        height={89.767}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10269"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10269"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
